/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Numeric, 1 = Enum, 2 = SeverityList, 3 = Composite
 */
export enum SeverityTelemetryMetricKind {
    Numeric = 0,
    Enum = 1,
    SeverityList = 2,
    Composite = 3
}

